module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n    <div class="col-md-8 col-xs-8">\n        <h3>'+
((__t=( name ))==null?'':_.escape(__t))+
' ';
 if (canEdit) { 
__p+='<span class="glyphicon glyphicon-pencil text-muted clickable edit-header"\n                                                  aria-hidden="true" id="edit-data"></span>';
 } 
__p+='</h3>\n    </div>\n    ';
 if (isSelf || byAdmin) { 
__p+='\n    <div class="dropdown col-md-2 col-xs-2">\n        <button id="actions" class="btn button-right" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n            Actions\n            <span class="caret"></span>\n        </button>\n        <ul class="dropdown-menu" aria-labelledby="actions">\n            <li>\n                <a href="/#changepassword/'+
((__t=( id ))==null?'':__t)+
'" id="change-password">Change password</a>\n            </li>\n            ';
 if (byAdmin) { 
__p+='\n            <li>\n                <a id="reset-token" class="clickable">Reset token</a>\n            </li>\n            <li>\n                <a id="generate-instant-token" class="clickable">Generate instant token</a>\n            </li>\n            ';
 } 
__p+='\n            ';
 if (isSelf) { 
__p+='\n            <li>\n                <a id="logout-all" class="clickable">Log out on all computers</a>\n            </li>\n            ';
 } 
__p+='\n            <li>\n                <a href="/api/person/export/'+
((__t=( id ))==null?'':__t)+
'?exportType=ccr" target="_blank" id="export-ccr">Export CCR</a>\n            </li>\n            <li>\n                <a href="/api/person/export/'+
((__t=( id ))==null?'':__t)+
'?exportType=ccda" target="_blank" id="export-ccda" >Export CCDA</a>\n            </li>\n        </ul>\n    </div>\n    ';
 } 
__p+='\n    ';
 if (byAdmin) { 
__p+='\n    <div class="col-md-2 col-xs-2">\n        <button type="button" class="btn btn-danger button-right"  id="remove-person">Remove profile</button>\n    </div>\n    ';
 } 
__p+='\n</div>\n\n<div>\n    ';
 if (object.isMd) { 
__p+='\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Documents</dt>\n        <dd>\n            <div class="row">\n                <div class="col-md-1-5 col-xs-2">\n                    <span style="color: green;" class="glyphicon glyphicon-check"/> <a href="'+
((__t=( signedDocumentsLink ))==null?'':__t)+
'" target="_blank">Reviewed</a>\n                </div>\n                <div class="col-md-1-5 col-xs-2">\n                    <span style="color: orange;" class="glyphicon glyphicon-hourglass"/> <a href="'+
((__t=( pendingDocumentsLink ))==null?'':__t)+
'" target="_blank">Pending</a>\n                </div>\n                <div class="col-md-1-5 col-xs-2">\n                    <span class="glyphicon glyphicon-file"/> <a href="'+
((__t=( allDocumentsLink ))==null?'':__t)+
'" target="_blank">All</a>\n                </div>\n            </div>\n        </dd>\n    </dl>\n    ';
 } 
__p+='\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Name</dt>\n        <dd>'+
((__t=( object.firstName ))==null?'':_.escape(__t))+
' '+
((__t=( object.lastName ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Birth date</dt>\n        <dd>'+
((__t=( birthDate ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Created time</dt>\n        <dd>'+
((__t=( formattedDateTime(createdTime) ))==null?'':__t)+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>NPI</dt>\n        <dd>'+
((__t=( object.npi ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Position</dt>\n        <dd>'+
((__t=( position ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>SSN</dt>\n        <dd>'+
((__t=( object.ssn ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Phone</dt>\n        <dd>'+
((__t=( tels ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Fax</dt>\n        <dd>'+
((__t=( faxes ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Email</dt>\n        <dd>'+
((__t=( emails ))==null?'':_.escape(__t))+
'</dd>\n    </dl>\n</div>\n\n<div id="save-confirmation-modal"></div>\n<div id="logout-all-confirmation-modal"></div>\n<div id="message-dialog"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/person-data.html
// module id = 346
// module chunks = 0